/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// oxlint-disable-next-line no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ClassicBoardSettingsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const classicBoardSettingsEntryPoint: EntryPoint<
	ClassicBoardSettingsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ClassicBoardSettingsEntryPointComponent>(
		/* webpackChunkName: "async-classic-board-settings-entrypoint" */ './BoardSettingsSwitcher.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => {
		return {};
	},
});
